export const Authorization = 'Authorization';
export const Token = 'token';
export const UserInfo = 'userInfo';
export const BotzillaRole = {
  ADMIN: 3,
  COMPANY: 2,
  ELEVATED_USER: 1,
  USER: 0,
};
export const BotzillaRoleReq = {
  Home: BotzillaRole.USER,
  Knowledge: BotzillaRole.ELEVATED_USER,
  Chat: BotzillaRole.USER,
  CreateChat: BotzillaRole.ELEVATED_USER,
  GetCompanyLimits: BotzillaRole.USER,
  Flow: BotzillaRole.COMPANY,
  File: BotzillaRole.COMPANY,
  SettingsSystem: BotzillaRole.ADMIN,
  SettingsModel: BotzillaRole.ADMIN,
  SettingsTeam: BotzillaRole.COMPANY,
  SettingsBotzillaAdmin: BotzillaRole.ADMIN,
  SettingsChatbotRights: BotzillaRole.COMPANY,
  SettingsCompanyCreateUser: BotzillaRole.COMPANY,
  SettingsCompanyTokens: BotzillaRole.ELEVATED_USER,
  SettingsAdminTokens: BotzillaRole.ADMIN,
  SettingsAdminRequests: BotzillaRole.ADMIN,
  SettingsAdminCreateUser: BotzillaRole.ADMIN,
  SettingsApi: BotzillaRole.ADMIN,
  BotzillaPackages: BotzillaRole.ADMIN,
  SettingsCompanyRequests: BotzillaRole.COMPANY,
};
